<p-galleria *ngIf="isVisible"
	[value]="images"
	[numVisible]="25"
	[(activeIndex)]="activeIndex"
	[responsiveOptions]="responsiveOptions"
	[circular]="true" [fullScreen]="true" [(visible)]="isVisible"
	[showThumbnails]="showThumbnails" [showItemNavigators]="showItemNavigators" [showThumbnailNavigators]="false"> 
	
    <ng-template pTemplate="item" let-img>
		<!-- Options:  https://github.com/wittlock/ngx-image-zoom#available-options -->
		<lib-ngx-image-zoom
			#imageZoomComponent
			*ngIf="!reinitializingNgxImageZoom" [ngClass]="{'showing-thumbnails': showThumbnails}"
			[enableScrollZoom]="true"
			[magnification]="1.75"
			[maxZoomRatio]="10"
			[scrollStepSize]="0.25"
			[thumbImage]="img.dataUrl"
			[style]="zoomingEnabled ? 'cursor: zoom-in' : ''"
			zoomMode="toggle-click"
		></lib-ngx-image-zoom>
	</ng-template>

	<ng-template pTemplate="footer">
		<div class="custom-galleria-footer" [ngClass]="{'showing-thumbnails': showThumbnails}">
			<button pButton icon="pi pi-list" (click)="onThumbnailButtonClick()"></button>

			<span class="title-container">
				<span>{{activeIndex + 1}}/{{images.length}}</span>
				<span class="title">{{images[activeIndex].fileName}}</span>
				<span>{{images[activeIndex].description}}</span>
			</span>

			<a pButton [href]="images[activeIndex].src" icon="pi pi-save" class="p-ml-auto"></a>
		</div>
	</ng-template>
	
    <ng-template pTemplate="thumbnail" let-img>
        <div id="thumbnail-container" class="p-grid p-nogutter p-justify-center">
            <img [src]="img.thumbnailSrc" />
        </div>
	</ng-template>
</p-galleria>